export default __webpack_public_path__ + "static/cta_dash_image_large-6851a8bb1cad08ec939d2412f261ba6d.svg";